import React, { Component } from "react";
import { FormInput as SemanticFormInput } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { observer } from "mobx-react";
import NestStore from "../../../stores/NestStore";

@observer
class FormInput extends Component {
  handleOnChangeInput = e => {
    const { dataStore, castValue } = this.props;
    const value = castValue ? castValue(e.target.value) : e.target.value;
    _.set(dataStore, e.target.name, value);
    const error = _.get(dataStore.errorMessages, e.target.name, undefined);
    if (error) {
      _.unset(dataStore.errorMessages, e.target.name);
    }
  };

  render() {
    const {
      dataStore,
      defaultValue,
      name,
      options,
      onChange,
      castValue,
      parseValue,
      errorPointing,
      error,
      ...props
    } = this.props;
    const value = _.get(dataStore, name, defaultValue || "") || defaultValue || "";
    const valueError = _.get(dataStore.errorMessages, name, undefined);
    return (
      <SemanticFormInput
        value={parseValue ? parseValue(value) : value}
        name={name}
        error={valueError ? { content: valueError, pointing: errorPointing } : error}
        onChange={onChange || this.handleOnChangeInput}
        {...props}
      />
    );
  }
}
FormInput.propTypes = {
  ...SemanticFormInput.propTypes,
  dataStore: PropTypes.instanceOf(NestStore).isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  errorPointing: PropTypes.oneOf(["below", "above", "left"]),
  castValue: PropTypes.func, // could be useful if you want to cast a value entered
  parseValue: PropTypes.func, // could be useful if you want to parse value to form value
};
FormInput.defaultProps = {
  errorPointing: "above",
};
export default FormInput;
